const formatters = new Map<string, Intl.NumberFormat>();

/**
 * Cached `Intl.NumberFormat`. Constructing one costs milliseconds on Hermes,
 * and the pricing tables format hundreds of values per render.
 */
export const getNumberFormatter = (
  locale?: string,
  options?: Intl.NumberFormatOptions,
): Intl.NumberFormat => {
  const key = `${locale ?? ''}|${JSON.stringify(options ?? {})}`;
  const cached = formatters.get(key);
  if (cached) {
    return cached;
  }

  const formatter = new Intl.NumberFormat(locale, options);
  formatters.set(key, formatter);
  return formatter;
};
